import { render } from "./ManagePlaylist.vue?vue&type=template&id=0b60b91f"
import script from "./ManagePlaylist.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagePlaylist.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Playlists/ManagePlaylist.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b60b91f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b60b91f', __exports__)) {
    api.reload('0b60b91f', __exports__)
  }
  
  module.hot.accept("./ManagePlaylist.vue?vue&type=template&id=0b60b91f", () => {
    api.rerender('0b60b91f', render)
  })

}


export default __exports__